// Vendor Components
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';

// Components
import Form from '../core/form';
import Input from '../core/input';
import PasswordResetSuccess from './password-reset-success';
import SubmitButton from '../core/submit-button';

// Containers
import FormData from '../../containers/form-data';

// Styles
import './reset-password-form.scss';

function ResetPasswordForm({formName}) {
    const getCustomFieldProps = (fieldName) =>
        ({
            user: {
                validate: ['username'],
            },
            credentials: {
                validate: ['password'],
            },
            passwordConfirm: {
                validate: [validatePasswordMatch, 'password'],
            },
        })[fieldName];

    const getFieldProps = (fieldName, type) => ({
        className: type === 'checkbox' ? 'reset-password-form--checkbox' : 'reset-password-form--input',
        label: startCase(fieldName),
        name: fieldName,
        inputType: type,
        ...getCustomFieldProps(fieldName),
    });

    const validatePasswordMatch = (formData) =>
        formData.credentials &&
        formData.passwordConfirm &&
        formData.credentials.length >= 8 &&
        formData.passwordConfirm.length >= 8 &&
        formData.passwordConfirm !== formData.credentials
            ? 'Passwords do not match'
            : undefined;

    return (
        <div className="reset-password-form">
            <FormData formName={formName}>
                {() => (
                    <Form
                        className="reset-password-form--form"
                        name={formName}
                        noAuthenticationRequired={true}
                        submitData={true}
                        successPage={<PasswordResetSuccess />}
                    >
                        <Input {...getFieldProps('user')} disableAutofill={true} label="User Name" />
                        <Input
                            {...getFieldProps('credentials', 'password')}
                            disableAutofill={true}
                            label="New Password"
                        />
                        <Input
                            {...getFieldProps('passwordConfirm', 'password')}
                            disableAutofill={true}
                            label="Retype New Password"
                        />

                        <SubmitButton className="reset-password-form--submit-button" label="Submit" />
                    </Form>
                )}
            </FormData>
        </div>
    );
}

ResetPasswordForm.propTypes = {
    formName: PropTypes.string,
};

export default ResetPasswordForm;
